module.exports = __webpack_public_path__ + "static/media/oauth_guide.357200ef.png";